import { useQuery } from 'react-query';

import { PRIVACY_SETTINGS_KEY, getPrivacySettings } from '@utils/backend-api/settings';

export default function usePrivacySettings() {
  const { data: privacySettings, isLoading: isLoadingPrivacySettings } = useQuery(
    PRIVACY_SETTINGS_KEY,
    getPrivacySettings
  );

  return { privacySettings, isLoadingPrivacySettings };
}
